import $ from 'jquery';
import whatInput from 'what-input';
import A11yUtils from '@core/base/scripts/utils/a11y-utils';
import Utils from '@core/base/scripts/utils/utils.js';

export default class LinksTabpanels {

  constructor(container) {
    this.CLASSES = {
      show: 'links-tabpanels--show'
    };
    this.container=container;
    this.$tabPanels=null;
    this.isInit = false;
    this.$currentPanel = null;
    this.$lastTable = null;
    this.initialSize = null;
    this.$lastBtn = null;
  }

  init(table) {
    this.isInit = true;
    this.$tabPanels=$('.links-tabpanels',this.container);
    this.$currentPanel = table;

    this.initialSize = $(window).width();
  }

  show(elt) {
    this.$currentPanel = elt;

    if (this.$lastTable) {
      this.$lastTable.removeClass(`${this.CLASSES.show}`);
      this.reset();
    }
    this.$currentPanel.addClass(`${this.CLASSES.show}`);
    if (whatInput.ask() === 'keyboard') {
      this.$currentPanel.find(A11yUtils.FOCUSABLES).first().focus();
    }
    this.$lastTable = this.$currentPanel;
    this.resize();
  }

  clean() {
  }

  reset(elt) {
    this.clean();
  }

  resize() {
    // if(this.$tabPanels && this.$tabPanels.length>1){
    //   const maxHeight = Math.max.apply(
    //     null,
    //     this.$tabPanels
    //     .map(function () {
    //       return $(this).height();
    //     })
    //     .get()
    //   );
    //   this.$tabPanels.height(maxHeight);
    // }
  }

}
